import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    headerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      top: 0,
      right: 0,
      zIndex: 99,
    },
    header: {
      display: 'flex',
      backgroundColor: STYLE.COLOR.WHITE,
      borderBottom: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '15px 30px',
      gap: '16px',
      textAlign: 'center',
      '@media (max-width: 768px)': {
        justifyContent: 'space-between',
      },
      '@media (max-width: 1024px)': {
        padding: '10px 24px',
      },
      '@media (max-width: 600px)': {
        padding: '10px 16px',
      },
    },
    warningBar: {
      position: 'relative !important' as any,
      top: 'auto !important' as any,
      left: 'auto !important' as any,
    },
    headerRightSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    loginButton: {
      height: '40px !important',
      minWidth: 'inherit !important',
      paddingLeft: '32px !important',
      paddingRight: '32px !important',
    },
    loginIcon: {
      marginRight: '8px',
      '@media (max-width: 1024px)': { display: 'none' },
    },
    fcaIcon: {
      display: 'none',
      '@media (max-width: 768px)': { display: 'block !important' },
    },
    // Opt-in (fullWidthHeader): full-width white bar with logo left, controls right.
    headerWrapperFull: {
      left: 0,
    },
    headerFull: {
      width: '100%',
      justifyContent: 'space-between',
    },
    fcaIconVisible: {
      display: 'block',
    },
    internetIcon: {
      marginRight: '16px',
      '@media (max-width: 768px)': { marginRight: '0px' },
    },
  }),
);

export const useStylesLanguageSwitcher = makeStyles((theme: any) =>
  createStyles({
    languageSwitcher: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '@media (max-width: 768px)': { display: 'none !important' },
    },
    languageOption: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      cursor: 'pointer',
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: 400,
      color: STYLE.COLOR.TEXT2,
      position: 'relative',
      '&:not(:last-child)': { marginRight: '16px' },
    },
    languageOptionActive: {
      fontWeight: 500,
      color: STYLE.COLOR.ACCENT_PRIMARY,
    },
    hideText: {
      '@media (max-width: 768px)': { display: 'none !important' },
    },
    borderBottom: {
      position: 'absolute',
      bottom: -1.5,
      left: 0,
      width: '100%',
      height: '1.5px',
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
    },
    flagIcon: { marginRight: '8px' },
    menuContainer: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '@media (min-width: 768px)': { display: 'none !important' },
    },
    flagIconBig: { width: '24px', height: '24px', aspectRatio: '1 / 1' },
  }),
);

export const useStylesHelp = makeStyles((theme: any) =>
  createStyles({
    helpButton: {
      borderRadius: '12px',
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
      display: 'flex',
      alignItems: 'center',
      padding: '8px 12px',
      gap: '8px',
      textAlign: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
    },
    hideHelpButton: {
      '@media (max-width: 900px)': { display: 'none !important' },
    },
    helpText: {
      fontSize: '16px',
      fontWeight: 400,
      color: STYLE.COLOR.ACCENT_PRIMARY,
      lineHeight: '24px',
    },
  }),
);

export const useStylesWorkerAndAdminMenu = makeStyles((theme: any) =>
  createStyles({
    parent: {},
    avatarContainer: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    avatar: {
      width: '40px !important',
      height: '40px !important',
      backgroundColor: `${STYLE.COLOR.ERROR_LIGHTER} !important`,
      color: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
    },
    arrowIcon: {
      height: '24px',
      width: '24px',
      transition: 'all 0.2s ease-in',
      '& path': { stroke: STYLE.COLOR.ACCENT_PRIMARY },
    },
    arrowIconRotated: {
      height: '24px',
      width: '24px',
      transform: 'rotate(180deg)',
      transition: 'all 0.2s ease-in',
    },
    menu: {
      '& .MuiMenu-paper': {
        padding: 12,
        borderRadius: 12,
        marginTop: 8,
        border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      },
      '& .MuiList-root': {
        padding: '0px !important',
      },
      '& .MuiMenuItem-root': {
        padding: 8,
        borderRadius: 8,
        color: STYLE.COLOR.TEXT1,
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
        gap: 8,
        '&:hover': {
          backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
        },
        '&.selected': {
          backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
          color: STYLE.COLOR.ACCENT_PRIMARY,
          fontWeight: 500,
        },
      },
      '@media (max-width: 768px)': {
        '& .MuiPaper-root': {
          top: '52px !important',
          left: '0px !important',
          right: '0px !important',
          maxWidth: 'inherit !important',
          borderRadius: 0,
          boxShadow: STYLE.COLOR.HEADER_MENU_BOX_SHADOW,
          padding: '0px !important',
        },
        '& .MuiMenuItem-root': {
          padding: '12px 16px 12px 16px !important',
        },
      },
    },
    hideMenuItem: {
      '@media (min-width: 900px)': { display: 'none !important' },
    },
    supervisorModeMenuItem: {
      justifyContent: 'space-between !important',
    },
    supervisorModeMenuItemContent: { display: 'flex', alignItems: 'center', gap: 8, marginRight: 22 },
    buildInfo: {
      fontWeight: 400,
      fontSize: '10px',
      lineHeight: '20px',
      color: STYLE.COLOR.TEXT3,
      padding: '4px 8px 8px 8px',
    },
  }),
);
